<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>{{ form.companyName }} แก้ไข Shipper</h2>
      </b-col>
      <b-col>
        <b-button class="float-right ml-4" variant="primary" @click="save">บันทึก</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col>
    </b-row>
    <b-form>
      <b-row>
        <b-col md="12" lg="12">
          <b-card>
            <div slot="header">
              <strong>ส่วนที่ 1 : ข้อมูลทั่วไป</strong>
            </div>
            <b-row>
              <b-col md="6">
                <TextInput
                  :value="$v.form.companyName"
                  id="companyName"
                  feedback="จำเป็นต้องระบุ"
                  label="ชื่อบริษัท"
                  placeholder="ตัวอย่าง: ร่ำรวยขนส่ง"
                  :isRequired="true"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="loadOk">
        <b-col>
          <b-card>
            <div slot="header">
              <strong>Logo</strong>
            </div>
            <DocLogo
              docType="company-logo"
              v-bind:refId="form.companyId"
              v-bind:preventDelete="false"
            />
            <UploadDoc docType="company-logo" v-bind:refId="form.companyId" />
          </b-card>
        </b-col>
      </b-row>
    </b-form>
    <b-row class="mt-2 mb-2">
      <b-col>
        <b-button class="float-right ml-4" variant="primary" @click="save">บันทึก</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import ModalLoading from '../../../components/ModalLoading'

import { validationMixin } from 'vuelidate'
import { required, email, helpers, url, numeric, decimal, between } from 'vuelidate/lib/validators'

import TextInput from '../../../components/TextInput'
import SelectInput from '../../../components/SelectInput'
import MultiSelectTag from '../../../components/MultiSelectTag'

const thPhoneNumber = helpers.regex('thPhoneNumber', /^0[0-9]{9}$/)

import Company from '../../../services/http/Company'
import TruckType from '../../../services/http/TruckType'
import AppInfo from '../../../services/http/AppInfo'

import Multiselect from 'vue-multiselect'

import DocLogo from '../../../components/DocLogo'
import DocList from '../../../components/DocList'
import UploadDoc from '../../../components/UploadDoc'

export default {
  mixins: [validationMixin],
  components: {
    ModalLoading,
    TextInput,
    SelectInput,
    Multiselect,
    MultiSelectTag,
    DocLogo,
    DocList,
    UploadDoc
  },
  data () {
    return {
      previewBaseUrl: process.env.VUE_APP_LOGISTY_PROFILE_LINK,
      form: {
        companyName: null,
      },

      loadOk: false
    }
  },
  validations: {
    form: {
      companyName: {
        required
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      // Window.Event.$emit('showModalLoading')
      var company = new Company()
      try {
        var loaded = await company.getOneCompanyProfile(this.$route.params.companyId)
        if (loaded.code === 1) {

          // Object.assign(this.form, loaded.data[0])

          this.form.companyName = loaded.data[0].name
          this.form.companyId = loaded.data[0]._id

          this.loadOk = true

        }
      } catch (error) {
        console.log(error)
        alert(error.message)
      }


      // Window.Event.$emit('closeModalLoading')
    },
    async save () {
      this.$v.$touch()

      if (this.$v.$anyError) {
        return
      }


      Window.Event.$emit('showModalLoading')


      // prepare data for save
      this.form.name = this.form.companyName

      console.log(this.form)
      var company = new Company()

      try {
        var updated = await company.updateCompanyProfile(this.form)

      } catch (error) {
        console.log(error)
        alert(error.message)
      }

      Window.Event.$emit('closeModalLoading')

      if (updated.code === 1) {
        alert('สำเร็จ')
        this.init()
      } else {
        alert(update.error)
      }

    },
    goBack () {
      this.$router.push({
        name: 'บริษัททั้งหมด'
      })
    }
  }
}
</script>
